import TwoColumnLayout from "../Layout/TwoColumnLayout";
import Hero from "../Layout/Hero";
import FormController from "../Layout/FormController";
import FormAllen from "../Forms/FormAllen";

function PageAllen(props){
    return <div>
        <TwoColumnLayout>
            <Hero
                backgroundDesktop={"/Allen/Allen.png"}
                backgroundMobile={"/Allen/Allen-mobile.png"}
            ></Hero>
            <FormController
                devMode={process.env.NODE_ENV === "development"}
                formName={"allen"}
                form={FormAllen}
                formHeader={<>
                    <h1 className={"text-3xl text-white font-form"}>Cadillac Iconic Experiences: 2023 PGA Championship ‘Next Day Play’ with Josh Allen</h1>
                    <p className={"text-white mb-4 mt-2"}>One winner and two guests will win a trip to the final round of the 2023 PGA Championship, then play the course with Buffalo Bills QB Josh Allen the day after.</p>
                </>}
                disclaimerText={<>
                    <p>NO PURCHASE OR PAYMENT NECESSARY TO ENTER OR WIN. Open to legal residents of the 50 U.S./D.C., age 18+. Void where prohibited. Sweepstakes starts at 12:00:01 AM ET on 04/14/23; ends at 11:59:59 PM ET on 05/09/23. Total ARV of all prizes: $15,870. Limit: One (1) Entry per person. For full Official Rules, <a className={"underline"} href={"https://www.pga.com/pga-of-america/cadillac-iconic-experiences-rules"} target={"_blank"} rel={"noreferrer"}>click here</a>. Sponsor: The Professional Golfers’ Association of America, 100 Avenue of the Champions, Palm Beach Gardens, FL 33418.</p>
                </>}
            ></FormController>
        </TwoColumnLayout>
    </div>
}

export default PageAllen;
